import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import API, { ThenArg } from '../../services/API';
import { connect } from 'react-redux';
import {
  langSelector,
  contactInfoSelector,
  partialSearchProductsSelector,
  partialSearchProductsIsFetchingSelector,
  partialSearchCategoriesSelector,
  partialSearchCategoriesIsFetchingSelector,
  topMenuBrandsSelector,
} from '../App/selectors';
import Header from '../../components/Header/Header';
import { productCategoriesSelector } from './selectors';
import { cartDataSelector } from '../Cart/cartSlice';

interface Props {
  user: any;
  brands: any;
  lang: string;
  productCategories: ThenArg<typeof API.loadTree>;
  dispatch: (action: any) => void;
  socialUrls: {
    fbUrl: string;
    igUrl: string;
    ytUrl: string;
  };
  contact: {
    email: string;
    phone: string;
  };
  partialSearchProducts: ThenArg<typeof API.searchProducts>;
  partialSearchProductsIsFetching: boolean;
  partialSearchCategories: ThenArg<typeof API.loadCategories>;
  partialSearchCategoriesIsFetching: boolean;
  cartData: ThenArg<typeof API.getCart>;
}

class ContainerHeader extends React.Component<Props> {
  public render() {
    const {
      socialUrls,
      lang,
      contact,
      dispatch,
      productCategories,
      partialSearchProducts,
      partialSearchProductsIsFetching,
      partialSearchCategories,
      partialSearchCategoriesIsFetching,
      user,
      cartData,
      brands,
    } = this.props;

    return (
      <Header
        user={user}
        dispatch={dispatch}
        socialUrls={socialUrls}
        lang={lang}
        contact={contact}
        items={productCategories}
        partialSearchProducts={partialSearchProducts}
        partialSearchProductsIsFetching={partialSearchProductsIsFetching}
        partialSearchCategories={partialSearchCategories}
        partialSearchCategoriesIsFetching={partialSearchCategoriesIsFetching}
        cartData={cartData}
        brands={brands}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    lang: langSelector(state),
    brands: topMenuBrandsSelector(state),
    contact: contactInfoSelector(state),
    socialUrls: state.general.socialUrls,
    productCategories: productCategoriesSelector(state),
    partialSearchProducts: partialSearchProductsSelector(state),
    partialSearchProductsIsFetching: partialSearchProductsIsFetchingSelector(
      state,
    ),
    partialSearchCategories: partialSearchCategoriesSelector(state),
    partialSearchCategoriesIsFetching: partialSearchCategoriesIsFetchingSelector(
      state,
    ),
    user: state.auth.user,
    cartData: cartDataSelector(state),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'ContainerHeader' })(ContainerHeader),
);
